import { render, staticRenderFns } from "./PlanDelete.vue?vue&type=template&id=50fe7bd5"
import script from "./PlanDelete.vue?vue&type=script&lang=js"
export * from "./PlanDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports